'use strict';

var tslib = require('tslib');
var React = require('react');
var cn = require('classnames');
var styled = require('styled-components');
var lightThemeColors = require('@prisjakt/design-tokens/light-theme-colors');
var measurements = require('@prisjakt/design-tokens/measurements');
var index = require('./index-6f152094.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
    if (e && e.__esModule) return e;
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n["default"] = e;
    return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var cn__default = /*#__PURE__*/_interopDefaultLegacy(cn);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var lightThemeColors__namespace = /*#__PURE__*/_interopNamespace(lightThemeColors);

var StyledBadge = styled__default["default"].div.withConfig({ displayName: "StyledBadge", componentId: "-12o65a4" })(templateObject_1 || (templateObject_1 = tslib.__makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 0.125rem ", ";\n  ", ";\n\n  > svg {\n    ", ";\n  }\n"], ["\n  display: inline-flex;\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", ";\n  padding: 0.125rem ", ";\n  ", ";\n\n  > svg {\n    ", ";\n  }\n"])), function (p) { var _a, _b, _c; return (_c = (_b = (_a = p.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b[p.bgColor]) !== null && _c !== void 0 ? _c : lightThemeColors__namespace[p.bgColor]; }, function (p) { return (p.circular ? '50%' : '0.225rem'); }, measurements.spacing050, function (p) {
    return !p.hasText &&
        p.circular &&
        " border-radius:50%;\n      padding:".concat(measurements.spacing025, ";\n      height:auto;\n    ");
}, function (p) { return p.hasText && "margin-right:0.25rem;"; });
var StyledText = styled__default["default"](index.Text).withConfig({ displayName: "StyledText", componentId: "-1upcr00" })(templateObject_2 || (templateObject_2 = tslib.__makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (p) { var _a, _b, _c; return (_c = (_b = (_a = p.theme) === null || _a === void 0 ? void 0 : _a.colors) === null || _b === void 0 ? void 0 : _b[p.$textColor]) !== null && _c !== void 0 ? _c : lightThemeColors__namespace[p.$textColor]; });
var templateObject_1, templateObject_2;

var _a;
exports.Size = void 0;
(function (Size) {
    Size["NORMAL"] = "normal";
    Size["SMALL"] = "small";
})(exports.Size || (exports.Size = {}));
var scales = (_a = {},
    _a[exports.Size.NORMAL] = {
        iconSize: 16,
        textSize: index.FontScale.S,
    },
    _a[exports.Size.SMALL] = {
        iconSize: 12,
        textSize: index.FontScale.XS,
    },
    _a);
var COLORS = {
    RED: {
        bgColor: 'redio100',
        fgColor: 'redio700',
    },
    RED_INVERTED: {
        bgColor: 'redio500',
        fgColor: 'base0',
    },
    GREEN: {
        bgColor: 'positive100',
        fgColor: 'positive700',
    },
    GREEN_INVERTED: {
        bgColor: 'positive700',
        fgColor: 'base0',
    },
    BLUE: {
        bgColor: 'informative100',
        fgColor: 'informative700',
    },
    BLUE_INVERTED: {
        bgColor: 'informative700',
        fgColor: 'base0',
    },
    YELLOW: {
        bgColor: 'notice100',
        fgColor: 'notice900',
    },
    YELLOW_INVERTED: {
        bgColor: 'yellove700',
        fgColor: 'base0',
    },
    GREY: {
        bgColor: 'base100',
        fgColor: 'base600',
    },
    GREY_INVERTED: {
        bgColor: 'base500',
        fgColor: 'base0',
    },
};
var Colors;
(function (Colors) {
    Colors["RED"] = "RED";
    Colors["RED_INVERTED"] = "RED_INVERTED";
    Colors["GREEN"] = "GREEN";
    Colors["GREEN_INVERTED"] = "GREEN_INVERTED";
    Colors["BLUE"] = "BLUE";
    Colors["BLUE_INVERTED"] = "BLUE_INVERTED";
    Colors["YELLOW"] = "YELLOW";
    Colors["YELLOW_INVERTED"] = "YELLOW_INVERTED";
    Colors["GREY"] = "GREY";
    Colors["GREY_INVERTED"] = "GREY_INVERTED";
})(Colors || (Colors = {}));

var Badge = function (_a) {
    var _b;
    var Icon = _a.icon, text = _a.text, _c = _a.color, color = _c === void 0 ? 'GREY' : _c, _d = _a.circular, circular = _d === void 0 ? false : _d, _e = _a.size, size = _e === void 0 ? exports.Size.NORMAL : _e, container = _a.container, containerProps = _a.containerProps, variant = _a.variant, className = _a.className, style = _a.style;
    var _f = COLORS[color], fgColor = _f.fgColor, bgColor = _f.bgColor;
    var currentScale = (_b = scales[size]) !== null && _b !== void 0 ? _b : scales.normal;
    if (!Icon && !text) {
        return null;
    }
    return (React__default["default"].createElement(StyledBadge, tslib.__assign({ bgColor: bgColor, circular: circular, hasText: !!text, as: container }, containerProps, { className: cn__default["default"](variant, className), style: style }),
        Icon && React__default["default"].createElement(Icon, { color: fgColor, size: currentScale.iconSize }),
        text && (React__default["default"].createElement(StyledText, { scale: currentScale.textSize, "$textColor": fgColor }, text))));
};

exports.Badge = Badge;
//# sourceMappingURL=index-30bc2299.js.map
